import { getDefaultClient, hasExtension } from '@dynamic-labs-sdk/client';
import { registerExtension } from '@dynamic-labs-sdk/client/core';

import { registerSolanaNetworkProviderBuilder } from '../../registerSolanaNetworkProviderBuilder';
import { recoverSolanaWalletConnectWalletProviders } from '../recoverSolanaWalletConnectWalletProviders';

export const WALLET_CONNECT_SOLANA_EXTENSION_KEY = 'walletConnectSolana';

export const addWalletConnectSolanaExtension = async (
  client = getDefaultClient()
) => {
  if (
    hasExtension({ extensionKey: WALLET_CONNECT_SOLANA_EXTENSION_KEY }, client)
  ) {
    return;
  }

  registerExtension(
    { extensionKey: WALLET_CONNECT_SOLANA_EXTENSION_KEY },
    client
  );

  registerSolanaNetworkProviderBuilder(client);

  await recoverSolanaWalletConnectWalletProviders(client);
};
